import {
  STUDY_MODE,
  PROGRAMME_TYPE,
  PROGRAMME_NAME,
  UNIVERSITY_CATEGORY,
} from '../constants';
import { PAGE_TEXT } from '../lang';
import { type SelectOption } from '../../../../../components';

const { PROGRAMME } = PAGE_TEXT;

export const modeOfStudyOptions: SelectOption[] = [
  {
    value: STUDY_MODE.FULL_TIME,
    label: PROGRAMME.FULL_TIME,
  },
  {
    value: STUDY_MODE.PART_TIME,
    label: PROGRAMME.PART_TIME,
  },
];

export const programmeOptions: SelectOption[] = [
  {
    value: PROGRAMME_NAME.MASTER_OF_PHILOSOPHY,
    label: PROGRAMME.MASTER_OF_PHILOSOPHY,
  },
  {
    value: PROGRAMME_NAME.DOCTOR_OF_PHILOSOPHY,
    label: PROGRAMME.DOCTOR_OF_PHILOSOPHY,
  },
];

export const programmeTypeOptions: SelectOption[] = [
  {
    value: PROGRAMME_TYPE.GENERAL_PROGRAMME,
    label: PROGRAMME.GENERAL_PROGRAMME,
  },
  {
    value: PROGRAMME_TYPE.DUAL_PHD_DEGREE_PROGRAMME,
    label: PROGRAMME.DUAL_PHD_DEGREE_PROGRAMME,
  },

  {
    value: PROGRAMME_TYPE.COLLABORATIVE_PHD_DEGREE_PROGRAMME,
    label: PROGRAMME.COLLABORATIVE_PHD_DEGREE_PROGRAMME,
  },
  // when backend enum is updated

  // {
  //   value: PROGRAMME_TYPE.JOINT_PHD_DEGREE_PROGRAMME,
  //   label: PROGRAMME.JOINT_PHD_DEGREE_PROGRAMME,
  // },
];

export const universityCategoryOptions: SelectOption[] = [
  {
    value: UNIVERSITY_CATEGORY.CHINA_MAINLAND,
    label: PROGRAMME.CHINA_MAINLAND,
  },
  {
    value: UNIVERSITY_CATEGORY.OVERSEAS,
    label: PROGRAMME.OVERSEAS,
  },
];
